import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { ReactNode } from 'react';
import LangEnum from '../../../../../../../../../lang/LangEnum';
import { TARGET_EMPTY_VALUE } from '../../../../../../../../target/target.constants';
import { useTranslation } from '../../../../../../../../translation/TranslationContext';

interface OrderTargetSummarySectionProps {
  label: LangEnum;
  chips: ReactNode[];
}

const OrderTargetSummarySection = ({ label, chips }: OrderTargetSummarySectionProps) => {
  const { translate } = useTranslation();

  return (
    <Stack sx={{ gap: 0.5 }}>
      <Typography variant="micro1" sx={{ color: 'text.secondary' }}>
        {translate(label)}
      </Typography>
      {chips.length > 0 ? (
        <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 0.5 }}>
          {chips}
        </Stack>
      ) : (
        <Typography variant="body2">{TARGET_EMPTY_VALUE}</Typography>
      )}
    </Stack>
  );
};

export default OrderTargetSummarySection;
